/* eslint-disable no-unused-vars */
export enum couponTypes { MONETARY = 'MONETARY', PERCENTAGE = 'PERCENTAGE' }

export enum paymentMethodCodes { CREDIT_CARD = 'credit_card', BANK_SLIP = 'bank_slip', PIX = 'pix' }
